import React, { useState } from 'react';
import FAQItem from './FAQItem';
import Step1Topic from './Step1Topic';
import Step2Format from './Step2Format';
import Step2FormatAndRoles from './Step2FormatAndRoles';
import Step3Participants from './Step3Participants';
import Step4Invites from './Step4Invites';
import styles from './CreateDebateWizard.module.css';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { Link, useNavigate, useLocation } from "react-router-dom";
import CompactNavbar from './../../CompactNavbar/CompactNavbar';
import { HiXCircle, HiTag, HiLightBulb, HiListBullet, HiMiniAdjustmentsVertical, HiMiniUserGroup, HiEnvelope } from 'react-icons/hi2';
import { useWizardConfig } from '../../../hooks/useWizardConfig';
import ContactSidebar from './../../ContactSidebar/ContactSidebar';
import { useAuth } from "../../../utils/AuthContext/authcontext";
import ProgressBar from './../../ProgressBar/ProgressBar';
import ArenaLoadingOverlay from './../ArenaLoadingOverlay/ArenaLoadingOverlay';
const functions = getFunctions();

async function handleCreateDebate(data, onComplete) {
  const fn = httpsCallable(functions, 'createarena');
  try {
    const { data: res } = await fn(data);
    onComplete(res.arenaId);
  } catch (e) {
    console.error('Error:', e);
  }
}


export default function CreateDebateWizard({ onSubmitDraft }) {
  const navigate = useNavigate(); 
  const [step,setStep] = useState(1);
  const [showOverlay, setShowOverlay] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const config = useWizardConfig();
  const [isContactOpen, setContactOpen] = useState(false);
  const {user, logout} = useAuth(); 
  const location = useLocation()
  const {state } = location; 
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(prev => (prev === index ? null : index));
  };

  const mlogout = () => {
  }

  /*const [data,setData]=useState({
    topic:'',source:'',url:'',format:'1v1',maxRounds:3,turnTime:60,visibility:'public',stake:0,
    participants:[],moderator:null,invites:[]
  });*/
  
  const [wizardData, setWizardData] = useState({
    topic: '',
	description: '',
    formatId: null,
	schedule: { date: '', time: '' },
    custom: { rounds: null, participants: null, duration: null, time: 0, wage: 0, visibility: 'public', teams: [], teamsnumber: [] },
    roles: { debaters: [], moderator: null },
  });
  
  const next = updates => {/*setData(d=>({...d,...updates}));*/ setStep(s=>Math.min(s+1,4));};
  const back=()=>setStep(s=>Math.max(s-1,1));
  //const submit=()=>onSubmitDraft(data);

  const goNext = () => setStep(step + 1);
  const goBack = () => step > 1 && setStep(step - 1);

  const update = (updateFn) => setWizardData(prev => ({ ...prev, ...updateFn(prev) }));

  const submit = () => {
	//console.log(wizardData);
	//return
	setIsSubmitting(true);
	setShowOverlay(true);
	handleCreateDebate(wizardData, (arenaId) => {
		setTimeout(() => {
			navigate(`/debates/${arenaId}`);
		}, 400); // allow overlay to complete
	});
  };
  
  if (!config) return <p>Loading...</p>;

  const steps = [
    { id:1, label:'Topic Selection', desc:config.descriptions['1'] },
    { id:2, label:'Debate Setup', desc:config.descriptions['2'] },
  ];
  
	const stepIcons = {
	  1: <HiLightBulb className="w-6 h-6"/>,
	  2: <HiMiniAdjustmentsVertical className="w-6 h-6"/>,
	  3: <HiMiniUserGroup className="w-6 h-6"/>,
	  4: <HiEnvelope className="w-6 h-6"/>
	};

  const faqFor = (id, formatFaqs) => {
    const baseFaqs = config?.faqs?.[id] || [];
    const injected = id === 2 ? formatFaqs : [];
    const allFaqs = [...baseFaqs, ...injected];
    return allFaqs.map((f, i) => (
      <FAQItem index={i} key={i} question={f?.question} isOpen={activeIndex === i} onToggle={handleToggle}>
        <p>{f.answer}</p>
      </FAQItem>
    ));
  };

  const faqFor_ = id => (config.faqs[id] || []).map((f,i)=>
    <FAQItem index={i} key={i} question={f.question} >
      <p>{f.answer}</p>
    </FAQItem>
  );

  //const StepComp = [null, Step1Topic, Step2Format, Step3Participants, Step4Invites][step];
 const StepComp = [null, Step1Topic, Step2FormatAndRoles][step];

 
  return (
    <>
	<div className={styles.header}>
		<CompactNavbar shownow={false} modal={true} scrollY={0} openContact={() => setContactOpen(true)}  openLogin={(user) => {user != null ? logout(true) : mlogout()}}/>
	</div>
    <div className={styles.container}>
      <main className={styles.main}>
        <div className={styles.header}>
          <h2>{stepIcons[steps[step - 1].id]} {steps[step - 1].label}</h2>
          <p>{steps[step - 1].desc}</p>
        </div>
        <div className={styles.progress}>
          <div className={styles.progressFill} style={{width:`${(step/2)*100}%`}}/>
        </div>
        <div className={styles.body}>
          <StepComp data={wizardData} custopic={{title: state?.title, url: state?.url, description: state?.description, thumbnail: state?.thumbnail}} onChange={update} onFinish={submit} onNext={step === 2 ? null : next} onBack={step > 1 ? back : null} faqs={(morefaq) => faqFor(step, morefaq)}/>
        </div>
      </main>
    </div>
	{isSubmitting ? <ProgressBar onComplete={() => console.log('Ready to navigate')} /> : <></>}
	{showOverlay && <ArenaLoadingOverlay msg={"Building your arena..."} onComplete={() => {}} />}
	<ContactSidebar isOpen={isContactOpen} onClose={() => setContactOpen(false)} />
	</>
  );

}
